import { useState } from "react";
import { useAuthenticationDataContext } from "../../Helpers/AuthenticationDataProvider";
import useFetchWrapper, { HttpResponse } from "../../Helpers/useFetchWrapper";
import { Props } from "./UploadImage.model";

export const useUploadImage = ({ onClose, currentUser, afterClosed }: Props) => {
	const [selectedImage, setSelectedImage] = useState<{ file: File | null, url: string }>({ file: null, url: '' });
	const [data, setData] = useState(currentUser);
	const { post, remove } = useFetchWrapper();
	const { setImageId } = useAuthenticationDataContext()

	const onClosePopup = () => {
		onClose();
		URL.revokeObjectURL(selectedImage.url);
		setSelectedImage({ file: null, url: '' });
	}

	const uploadImage = async (file: File) => {
    const response: HttpResponse<string> = await post(`/user/profile/image`, file, false, { 'Content-type': 'image/jpeg' });
		const imageId = response.parsedBody;
		setImageId(imageId);
		if (data && afterClosed) {
			setData({ ...data, imageId });
			afterClosed({ ...data, imageId });
		}
	}

	const deleteImage = async () => {
		await remove(`/user/profile/image`);
		setImageId("");
		if (data && afterClosed) {
			setData({ ...data, imageId: '' });
			afterClosed({ ...data, imageId: '' });
		}
	}

	const onDeleteImage = () => {
		deleteImage();
		setSelectedImage({ file: null, url: '' });
		onClose();
	}

	const onSaveUploadedImage = () => {
		if (selectedImage.file) {
			uploadImage(selectedImage.file);
		}
		setSelectedImage({ file: null, url: '' });
		onClose();
	}

	const onSelectImage = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (event && event.target.files) {
			selectedImage.url = URL.createObjectURL(event.target.files[0]);
			selectedImage.file = event.target.files[0];
			setSelectedImage({ ...selectedImage });
		}
	}

	return {
		onClosePopup,
		onDeleteImage,
		onSaveUploadedImage,
		onSelectImage,
		state: { selectedImage }
	}
}
